module.exports = "https://cdn.realtymogul.com/static/media/img_panel_tenants.61d6a8bd.jpg";